import { Skeleton } from 'app-template-lib/components/shadcn';

export function SkeletonCard() {
    return (
        <div className="flex flex-col space-y-3">
            <section>
                <Skeleton className="h-[50px] w-full rounded-xl m-2 mt-8" />
            </section>
            <div className="grid gap-4 grid-col-1 md:grid-cols-7">
                <Skeleton className="h-[300px] w-full col-span-4 rounded-xl m-2 " />
                <Skeleton className="h-[300px] w-full col-span-3 rounded-xl m-2 " />
            </div>

            <div>
                <section>
                    <Skeleton className="h-[50px] w-full rounded-xl m-2 " />
                </section>
                <section>
                    <Skeleton className="h-[300px] w-full rounded-xl m-2 " />
                </section>
            </div>
        </div>
    );
}
